import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_UTIMACO_PACKET_SWITCH = '/utmpktcfcis';

export const SET_UTIMACO_PACKET_SWITCH_LOADING = 'SET_UTIMACO_PACKET_SWITCH_LOADING';
export const GO_TO_UTIMACO_PACKET_SWITCH_CREATE = 'GO_TO_UTIMACO_PACKET_SWITCH_CREATE';
export const GO_TO_UTIMACO_PACKET_SWITCH_EDIT = 'GO_TO_UTIMACO_PACKET_SWITCH_EDIT';
export const GO_TO_UTIMACO_PACKET_SWITCH_VIEW = 'GO_TO_UTIMACO_PACKET_SWITCH_VIEW';
export const GO_TO_UTIMACO_PACKET_SWITCH_COPY = 'GO_TO_UTIMACO_PACKET_SWITCH_COPY';
export const GO_TO_UTIMACO_PACKET_SWITCH_LIST = 'GO_TO_UTIMACO_PACKET_SWITCH_LIST';
export const GET_UTIMACO_PACKET_SWITCH_LIST = 'GET_UTIMACO_PACKET_SWITCH_LIST';
export const GET_UTIMACO_PACKET_SWITCH_LIST_PENDING = 'GET_UTIMACO_PACKET_SWITCH_LIST_PENDING';
export const GET_UTIMACO_PACKET_SWITCH_LIST_FULFILLED = 'GET_UTIMACO_PACKET_SWITCH_LIST_FULFILLED';
export const GET_UTIMACO_PACKET_SWITCH = 'GET_UTIMACO_PACKET_SWITCH';
export const GET_UTIMACO_PACKET_SWITCH_PENDING = 'GET_UTIMACO_PACKET_SWITCH_PENDING';
export const GET_UTIMACO_PACKET_SWITCH_FULFILLED = 'GET_UTIMACO_PACKET_SWITCH_FULFILLED';
export const CREATE_UTIMACO_PACKET_SWITCH = 'CREATE_UTIMACO_PACKET_SWITCH';
export const CREATE_UTIMACO_PACKET_SWITCH_PENDING = 'CREATE_UTIMACO_PACKET_SWITCH_PENDING';
export const CREATE_UTIMACO_PACKET_SWITCH_FULFILLED = 'CREATE_UTIMACO_PACKET_SWITCH_FULFILLED';
export const CREATE_UTIMACO_PACKET_SWITCH_REJECTED = 'CREATE_UTIMACO_PACKET_SWITCH_REJECTED';
export const UPDATE_UTIMACO_PACKET_SWITCH = 'UPDATE_UTIMACO_PACKET_SWITCH';
export const UPDATE_UTIMACO_PACKET_SWITCH_FULFILLED = 'UPDATE_UTIMACO_PACKET_SWITCH_FULFILLED';
export const UPDATE_UTIMACO_PACKET_SWITCH_REJECTED = 'UPDATE_UTIMACO_PACKET_SWITCH_REJECTED';
export const DELETE_UTIMACO_PACKET_SWITCH = 'DELETE_UTIMACO_PACKET_SWITCH';
export const DELETE_UTIMACO_PACKET_SWITCH_FULFILLED = 'DELETE_UTIMACO_PACKET_SWITCH_FULFILLED';
export const DELETE_UTIMACO_PACKET_SWITCH_REJECTED = 'DELETE_UTIMACO_PACKET_SWITCH_REJECTED';
export const SELECT_UTIMACO_PACKET_SWITCH = 'SELECT_UTIMACO_PACKET_SWITCH';

export enum UtimacoPacketSwitchPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface UtimacoPacketSwitch {
  id: string
  AFID: string
  CFID: string
  LEA: string
  MCTYPE: string
  IPADDR: string
  PORT: string
  CCCMCID?: string;
}

export interface UtimacoPacketSwitchState {
  entities: UtimacoPacketSwitch[]
  selected: UtimacoPacketSwitch[],
  single: UtimacoPacketSwitch | null
  createdId: string | null
  ui: UtimacoPacketSwitchsUIState
}

export interface UtimacoPacketSwitchsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToUtimacoPacketSwitchListAction extends AnyAction {
  type: typeof GO_TO_UTIMACO_PACKET_SWITCH_LIST
}

export interface SetUtimacoPacketSwitchLoadingAction extends AnyAction {
  type: typeof SET_UTIMACO_PACKET_SWITCH_LOADING
  payload: { isLoading: boolean }
}

export interface GetUtimacoPacketSwitchListAction extends AnyAction {
  type: typeof GET_UTIMACO_PACKET_SWITCH_LIST
  payload: AxiosPromise<ServerResponse<UtimacoPacketSwitch>>
}

export interface GetUtimacoPacketSwitchListPendingAction extends AnyAction {
  type: typeof GET_UTIMACO_PACKET_SWITCH_LIST_PENDING
  payload: null
}

export interface GetUtimacoPacketSwitchListFulfilledAction extends AnyAction {
  type: typeof GET_UTIMACO_PACKET_SWITCH_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface GetUtimacoPacketSwitchAction extends AnyAction {
  type: typeof GET_UTIMACO_PACKET_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoPacketSwitch>>
}

export interface GetUtimacoPacketSwitchPendingAction extends AnyAction {
  type: typeof GET_UTIMACO_PACKET_SWITCH_PENDING
  payload: null
}

export interface GetUtimacoPacketSwitchFulfilledAction extends AnyAction {
  type: typeof GET_UTIMACO_PACKET_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface CreateUtimacoPacketSwitchThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateUtimacoPacketSwitchAction extends AnyAction {
  type: typeof CREATE_UTIMACO_PACKET_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoPacketSwitch>>
}

export interface CreateUtimacoPacketSwitchPendingAction extends AnyAction {
  type: typeof CREATE_UTIMACO_PACKET_SWITCH_PENDING
  payload: null
}

export interface CreateUtimacoPacketSwitchFulfilledAction extends AnyAction {
  type: typeof CREATE_UTIMACO_PACKET_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface CreateUtimacoPacketSwitchRejectedAction extends AnyAction {
  type: typeof CREATE_UTIMACO_PACKET_SWITCH_REJECTED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface UpdateUtimacoPacketSwitchThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateUtimacoPacketSwitchAction extends AnyAction {
  type: typeof UPDATE_UTIMACO_PACKET_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoPacketSwitch>>
}

export interface UpdateUtimacoPacketSwitchFulfilledAction extends AnyAction {
  type: typeof UPDATE_UTIMACO_PACKET_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface UpdateUtimacoPacketSwitchRejectedAction extends AnyAction {
  type: typeof UPDATE_UTIMACO_PACKET_SWITCH_REJECTED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface DeleteUtimacoPacketSwitchThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteUtimacoPacketSwitchAction extends AnyAction {
  type: typeof DELETE_UTIMACO_PACKET_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoPacketSwitch>>
}

export interface DeleteUtimacoPacketSwitchFulfilledAction extends AnyAction {
  type: typeof DELETE_UTIMACO_PACKET_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface DeleteUtimacoPacketSwitchRejectedAction extends AnyAction {
  type: typeof DELETE_UTIMACO_PACKET_SWITCH_REJECTED
  payload: AxiosResponse<ServerResponse<UtimacoPacketSwitch>>
}

export interface SelectUtimacoPacketSwitchAction extends AnyAction{
  type: typeof SELECT_UTIMACO_PACKET_SWITCH
  payload: UtimacoPacketSwitch[]
}

export type UtimacoPacketSwitchActionTypes =
  GoToUtimacoPacketSwitchListAction |
  SetUtimacoPacketSwitchLoadingAction |
  GetUtimacoPacketSwitchListAction |
  GetUtimacoPacketSwitchListPendingAction |
  GetUtimacoPacketSwitchListFulfilledAction |
  GetUtimacoPacketSwitchAction |
  GetUtimacoPacketSwitchPendingAction |
  GetUtimacoPacketSwitchFulfilledAction |
  CreateUtimacoPacketSwitchAction |
  CreateUtimacoPacketSwitchPendingAction |
  CreateUtimacoPacketSwitchFulfilledAction |
  CreateUtimacoPacketSwitchRejectedAction |
  UpdateUtimacoPacketSwitchAction |
  UpdateUtimacoPacketSwitchFulfilledAction |
  UpdateUtimacoPacketSwitchRejectedAction |
  DeleteUtimacoPacketSwitchAction |
  DeleteUtimacoPacketSwitchFulfilledAction |
  DeleteUtimacoPacketSwitchRejectedAction |
  SelectUtimacoPacketSwitchAction;
